// extracted by mini-css-extract-plugin
module.exports = {"invisibleSelect":"_1u1ngqga","option":"_2PYrbCKz","searchTitle":"FiQvhZWO","area":"_2glZyRiy","border":"_1Ml4l_uz","selectText":"_3zgGW-f8"};